<template>
  <div class="content">
    <span v-for="(value, name, index) in data" :key="index" class="datapoint">
      <b>{{ name }}</b>
      <b>{{ value }}</b>
    </span>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive } from "vue";

const url = `${process.env.VUE_APP_BACKEND}/stats`;
const data = reactive({
  entries: "",
  unlabeled: "",
  unverified: "",
  verified: "",
});

async function getStats() {
  console.log("Fetching Data from ", url);
  await fetch(url, {
    method: "GET",
  })
    .then((res) => res.json())
    .then((res) => {
      console.log(res);
      data.entries = res.entries;
      data.unlabeled = res.unlabeled;
      data.unverified = res.unverified;
      data.verified = res.verified;
    });
}

onMounted(() => {
  getStats();
});
</script>

<style scoped>
.datapoint {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  width: 50%;
}

b {
  color: var(--text);
  font-size: 1.5em;
  text-transform: capitalize;
}
</style>
